import React, {useEffect, useImperativeHandle, useRef} from "react";
import {OrderedListOutlined} from "@ant-design/icons";
import {Col, Form, Input, Modal, InputNumber,Row} from "antd";
import {useModel} from "../../../models";

const AdjustForm = ({formRef}) => {
    const [{selectedAccount,selectedCustomer}, {adjustAccount, setAdjustModelVisible}] = useModel("customer");
    const [form] = Form.useForm();

    useEffect(() => {
        console.log(selectedAccount)
        form.setFieldsValue({...selectedAccount,...selectedCustomer});
        form.setFieldsValue({accountType:"授信账户"});
    }, [selectedAccount]);

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        adjust: () => {
            form.validateFields().then(data => {
                console.log(selectedAccount)
                let {id,accountType} = selectedAccount
                let datas = {
                    ...data,
                    id,
                    accountType
                }
                adjustAccount({datas}).then(() => {
                    setAdjustModelVisible(false);
                });

            })
        },
        reset: () => {
            form.resetFields();
        },
    }));
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
            style={{marginRight: "50px"}}
        >
                    <Form.Item
                        name="customerName"
                        label="客户名称"
                    >
                        <Input disabled={true} placeholder="客户名称"/>
                    </Form.Item>
                    <Form.Item
                        name="accountType"
                        label="账户类型"
                    >
                        <Input disabled={true} placeholder="账户类型"/>
                    </Form.Item>
                    <Form.Item
                        name="creditLine"
                        label="授信额度"
                    >
                        <Input disabled={true} placeholder="授信额度"/>
                    </Form.Item>
                    <Form.Item
                        name="adjustmentlimit"
                        label="调整额度"
                        rules={[{required: true, message: '调整额度是必输项',}]}
                    >
                        <InputNumber  placeholder="调整额度"/>
                    </Form.Item>
                    <Form.Item
                        name="remarks"
                        label="备注"
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
        </Form>
    )
}

export default function () {
    const [{adjustModelVisible, selectedAccount}, {setAdjustModelVisible}] = useModel("customer")

    const formRef = useRef();

    const onOk = () => {
        formRef.current.adjust();

    }
    const onClose = () => {
        setAdjustModelVisible(false);
    }
    const Title = () => {
        return (
            <h3 style={{flex: "1"}}>
                <OrderedListOutlined/>
                <span className="margin-left-8">账户调额</span>
                <span className="margin-left-16">{selectedAccount.supplierName}-{selectedAccount.ccountTypeName}</span>
            </h3>
        )
    }
    return (
        <Modal
            title={<Title/>}
            width={500}
            visible={adjustModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <AdjustForm formRef={formRef}/>
        </Modal>
    );
}